module.exports = __webpack_public_path__ + "static/media/lic childrens plan.b2f15568.gif";


//////////////////
// WEBPACK FOOTER
// ./src/img/lic childrens plan.gif
// module id = 378
// module chunks = 0